var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsCaDelivery = function SvgNnIconFlagsCaDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-CA-delivery_svg__Lager_33",
    "data-name": "Lager 33",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-CA-delivery_svg__cls-1{fill:red}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    className: "nn-icon-flags-CA-delivery_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.74.25h24.98v33.31H12.74z",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.59 16.48-1.06.5 5.14 4.21a.66.66 0 0 1 .23.7l-.45 1.49c1.77-.21 3.36-.52 5.13-.71.16 0 .42.24.42.43l-.24 5.44h.86l-.13-5.43c0-.18.23-.46.39-.44 1.77.19 3.36.5 5.13.71l-.45-1.47a.66.66 0 0 1 .23-.7L35.93 17l-1.06-.5c-.47-.17-.34-.43-.17-1.07l.78-2.87-3 .63a.46.46 0 0 1-.54-.32l-.38-1.35-2.33 2.64c-.34.43-1 .43-.8-.56l1-5.38-1.35.7c-.38.21-.76.25-1-.13l-1.85-3.51-1.87 3.51c-.21.38-.59.34-1 .13l-1.35-.7 1 5.38c.22 1-.46 1-.8.56l-2.36-2.66-.38 1.35a.46.46 0 0 1-.54.32l-3-.63.78 2.87c.22.64.35.9-.12 1.07",
    className: "nn-icon-flags-CA-delivery_svg__cls-1"
  })));
};
export default SvgNnIconFlagsCaDelivery;